export const AlertDefaultSubject = 'Alert (<tmpl_var alert.name>) from Security Management Portal <tmpl_var settings.smpname>';

export const AlertDefaultBody = `<html>
<head>
  <tmpl_include_file notifyCss.inc>
  <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
</head>
<body class=BodyMain>
  This is an alert from Security Management Portal <tmpl_var settings.SMPName>.<br>
  <br>
  <table border=0 cellpadding=5 cellspacing=0 class=ViewTable>
    <tr class=ViewTableHead>
      <td colspan=2><B>Alert Information:</B></td>
    </tr>
    <tr class=ViewTableRow1><td>Name:</td><td><tmpl_var alert.name></td></tr>
    <tr class=ViewTableRow0><td>Description:</td><td><tmpl_var alert.description></td></tr>
    <tr class=ViewTableRow1><td>Log ID:</td><td><tmpl_var alert.logId></td></tr>
    <tr class=ViewTableRow0><td>Min. Severity:</td><td><tmpl_var alert.log_id></td></tr>
    <tr class=ViewTableRow1><td>Free Text:</td><td><tmpl_var alert.filter></td></tr>
    <tmpl_if alert.sameSource>
    <tr class=ViewTableRow0><td>Source:</td><td><tmpl_var alert.source></td></tr>
    </tmpl_if>
    <tr <tmpl_if alert.sameSource>class=ViewTableRow1><tmpl_else>class=ViewTableRow0></tmpl_if>
      <td>Recurrences:</td><td>Too <tmpl_if alert.atLeast>many<tmpl_else>few</tmpl_if> recurrences (<tmpl_var alert.recurrence>) during interval (<tmpl_var alert.timeInterval> minutes)</td>
    </tr>
  </table>
  <br>
</body>
</html>
`;